// removed by extract-text-webpack-plugin
module.exports = {"icon_suppliers_red":"icon_suppliers_red","nf-account-admin__side-panel":"nf-account-admin__side-panel","nf-supplier-search-clear-all":"nf-supplier-search-clear-all","ant-select-selector":"ant-select-selector","ant-select-selection-placeholder":"ant-select-selection-placeholder","rt-tr":"rt-tr","nf-tbl-header":"nf-tbl-header","nf-sp_grid":"nf-sp_grid","ReactTable":"ReactTable","rt-tbody":"rt-tbody"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/SupplierCapabilities/SupplierCapabilties.scss
// module id = 1333
// module chunks = 1